import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';

const EventRegionFilter = (props) => {
    const { filters, filterModal, handleFilterClick, closeModals, filterInputs, searchTypes, handleFilterSubmit, clearFilters, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'eventRegions'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && filters.eventRegions && Object.values(filters.eventRegions).indexOf(true) > -1) || filterModal === 'eventRegions'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Region
            </Filter>
            {filterModal === 'eventRegions' && (
                <FilterModal
                    title={'eventRegions'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('eventRegions')}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`eventRegions`}
                            filterInputs={filterInputs}
                            filtersPropName={`eventRegions`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    eventRegions: {
                                        ...filterInputs.eventRegions,
                                        [value]: !filterInputs.eventRegions[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default EventRegionFilter;
